module.exports = __webpack_public_path__ + "3af3bf7ac404329dde649543c9222690.pdf";